import styled from 'styled-components';
import { BasicButton } from '../../../component/button';
import { colors } from '../../../component/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 120px;
`;
export const Title = styled.p`
  font-family: DM Sans;
  font-size: 21px;
  font-style: normal;
  font-weight: 500;
  line-height: 29px;
  letter-spacing: 0.15000000596046448px;
  text-align: left;
`;
export const AddStoreBtn = styled(BasicButton)`
  width: 120px;
  padding: 11px 0px;
  border-radius: 8px;
`;

export const ListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 48px;
`;

export const SortContainer = styled.div`
  align-self: flex-end;
  display: flex;
  align-items: center;
  margin-top: 61px;
`;
export const SortText = styled(Title)`
  margin-right: 16px;
`;
export const CategoryListCard = styled.div``;

export const CategoryButtonSet = styled.div`
  background: #ffffff;
  border: 1px solid #a1a1a1;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  border-radius: 8px;
  width: 35%;
  margin: 25px auto;
  padding: 4px;
`;
export const CategoryButton = styled.div<{ isActive?: boolean }>`
  font-family: 'DM Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 170%;
  display: flex;
  align-items: center;
  text-align: center;
  cursor: pointer;
  letter-spacing: 0.25px;
  color: #a1a1a1;
  padding: 9px 20px;
  border-radius: 8px;
  color: ${({ isActive }) => (isActive ? '#F4F5F7' : '#42526E')};
  background-color: ${({ isActive }) =>
    isActive ? colors.sojiOrange : 'transparent'};
`;
